export default __webpack_public_path__ + "static/media/img1.54cf59c1.jpg";